module.exports = __webpack_public_path__ + "static/media/sergio.eb85c8dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/sergio.png
// module id = 346
// module chunks = 0